import { IhomepageSetting } from '@typings/setting/homepageSetting.interface';
import { LAYOUT_TYPE } from '@typings/setting/layoutType';
import { LOGO_TYPE } from '@typings/setting/logoType';
import { MENU_ITEM_TYPE } from '@typings/menu/menuItemType';
import { MENU_DESIGN_TYPE } from '@typings/menu/menuType';
import { FONT_FAMILY_TYPE } from '@typings/common/fontFamilyType';
import { MENU_TEXT_TYPE } from '@typings/menu/menuTextType';
import { CARD_BORDER_TYPE } from '@typings/setting/cardBorderType';
import { LAYOUT_DIR } from '@typings/setting/layoutDir';

export const homepageDefaultSetting: IhomepageSetting = {
  homepageSet: {
    faviconURL: '',
    homepageTitle: '홈페이지 타이틀',
    homepageDescription: '',
    logoImgURL: '',
    logoType: LOGO_TYPE.TEXT,
    ogImgURL: '',
  },
  menu: {
    imgURL: '',
    menuBackgroundColor: '#fff',
    menuFixed: true,
    menuTextColor: '#1C1A1A',
    menuHeight: '80px',
    menuWidth: '220',
    layoutWidth: '100%',
    menuType: MENU_DESIGN_TYPE.COLOR,
    menuItemType: MENU_ITEM_TYPE.TEXT,
    menuTextType: MENU_TEXT_TYPE.LEFT,
    menuFontFamily: FONT_FAMILY_TYPE.NANUM_GOTHIC,
  },
  ddayWidget: {
    showDdayWidget: false,
    designType: 'text'
  },
  layoutType: LAYOUT_TYPE.LEFT,
  layoutDir: LAYOUT_DIR.LEFT,
  background: {
    backgroundColor: '#fff',
    backgroundImgURL: '',
  },
  font: {
    textSize: '15px',
    textColor: '#1C1A1A',
    subTextColor: '#A9A9A9',
    headerFontFamily: FONT_FAMILY_TYPE.NANUM_GOTHIC,
    defaultFontFamily: FONT_FAMILY_TYPE.NANUM_GOTHIC,
  },
  button: {
    buttonBackgroundColor: '#4D4957',
    buttonTextColor: '#fff',
    buttonBorderRadius: '6px',
  },
  primary: {
    primaryColor: '#4D4957',
    subColor: '#BABCC5',
    inkColor: 'rgba(38, 35, 46, 0.08)',
    lineColor: '#E5E5E5',
  },
  card: {
    cardBackgroundColor: '#F7F7F7',
    cardBorderRadius: '6px',
    cardLineColor: '#E5E5E5',
    cardBorderImage: '',
    cardBorderType: CARD_BORDER_TYPE.SOLID,
    cardBorderWidth: 1,
    cardBorderOffset: 0,
    cardBlur: '4px',
  },
};
